import { combineReducers } from 'redux';

import { SET_LATERAL_IMAGE } from '../actions/lateralImage';
import { SET_IS_LOADING, SET_SHOW_MODAL } from '../actions/auth';
import { SET_SHOW_TOS } from '../actions/tos';
import { SET_SHOW_FORGOT_PASSWORD } from '../actions/login';
import {
    SET_SHOW_PASSWORDLESS_MODAL,
    SET_PASSWORDLESS_CREATE_ACCOUNT_FLOW,
} from '../actions/passwordless';

const isLoading = (state = true, { type, payload }) => {
    let nextState = state;

    if (type === SET_IS_LOADING) {
        nextState = payload;
    }
    return nextState;
};

const showModal = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === SET_SHOW_MODAL) {
        nextState = payload;
    }
    return nextState;
};

const showPasswordlessModal = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === SET_SHOW_PASSWORDLESS_MODAL) {
        nextState = payload;
    }
    return nextState;
};

const passwordlessCreateAccountFlow = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === SET_PASSWORDLESS_CREATE_ACCOUNT_FLOW) {
        nextState = payload;
    }
    return nextState;
};

const lateralImage = (state = {}, { type, payload }) => {
    let nextState = state;

    if (type === SET_LATERAL_IMAGE) {
        nextState = payload;
    }
    return nextState;
};

const showToS = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === SET_SHOW_TOS) {
        nextState = payload;
    }
    return nextState;
};

const showForgotPassword = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === SET_SHOW_FORGOT_PASSWORD) {
        nextState = payload;
    }
    return nextState;
};

export default combineReducers({
    isLoading,
    showModal,
    lateralImage,
    showToS,
    showForgotPassword,
    showPasswordlessModal,
    passwordlessCreateAccountFlow,
});
